import styled from 'styled-components/native';

export const Circle = styled.View`
  background-color: white;
  height: 35px;
  width: 35px;
  border-radius: 35px;
  border-color: #9B9B9B;
  border-width: 1px;
`